module.exports = __webpack_public_path__ + "static/media/cat.cf5a00e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/TheMoshiDifference/cat.jpg
// module id = 178
// module chunks = 0